export default "__VITE_ASSET__DXMKK7vG__"